/**
 * Color tokens from Figma design system
 *
 * MUI Mapping:
 * - primary → theme.palette.primary (spread directly)
 * - secondary → theme.palette.secondary (spread directly)
 * - neutral → theme.palette.grey (spread directly)
 *
 * Usage: Spread into MUI palette - new tokens auto-propagate
 */

export const primaryColors = {
  main: '#01579B',
  dark: '#003B5C',
  light: '#66D3EE',
  contrast: '#FFFFFF',
} as const;

export const secondaryColors = {
  main: '#00B5E2',
  dark: '#007E9E',
  light: '#33C3E7',
  contrast: '#FFFFFF',
} as const;

export const neutralColors = {
  50: '#DED4D7',
  100: '#BFC0C4',
  200: '#A7A8AC',
  300: '#909195',
  400: '#7A7B7E',
  500: '#666666',
  600: '#55575A',
  700: '#47484B',
  800: '#3F4042',
  900: '#333333',
} as const;

export type PrimaryColors = typeof primaryColors;
export type SecondaryColors = typeof secondaryColors;
export type NeutralColors = typeof neutralColors;
